import { Product } from 'utils/Product';
import backendService from './backend-service';
import { SetOptional } from 'type-fest';
import produce from 'immer';

export type NewProduct = Omit<Product, 'id'>;
export type UpdatedProduct = SetOptional<Product, 'image'>;

export const parseApiProduct = (apiProduct: unknown): Product => {
  const p = apiProduct as {
    id: string,
    category: string,
    image: string,
    price: string | number,
    quantity: string | number,
    stars: string | number,
    title: string,
    visible: string | boolean
  };
  return {
    ...p,
    quantity: typeof p.quantity === 'number' ? p.quantity : Number.parseInt(p.quantity),
    visible: typeof p.visible === 'boolean' ? p.visible : p.visible === 'true',
    price: typeof p.price === 'number' ? p.price : Number.parseFloat(p.price),
    stars: typeof p.stars === 'number' ? p.stars : Number.parseInt(p.stars),
  };
};

export const productToApiBody = (product: Product | UpdatedProduct | NewProduct) => {
  return {
    ...product,
    visible: product.visible ? 'true' : 'false',
  };
};

export const productRequests = {
  get: (id: string) => (backendService
    .get(`/product/${id}`)
    .then(res => res.data)
    .then(parseApiProduct)
  ),
  getAll: () => (backendService
    .get('/products')
    .then(res => res.data)
    .then(products => (products as unknown[]).map(parseApiProduct))
  ),
  getAllByVisibility: (visible: boolean) => (backendService
    .get(`/products?visible=${visible}`)
    .then(res => res.data)
    .then(products => (products as unknown[]).map(parseApiProduct))
  ),
  post: (newProduct: NewProduct) => (backendService
    .post('/product', productToApiBody(newProduct))
    .then(res => res.data)
    .then(parseApiProduct)),
  put: (updatedProduct: UpdatedProduct) => (backendService
    .put('/product', productToApiBody(updatedProduct))
    .then(res => res.data)
    .then(parseApiProduct)
  ),
  delete: (id: string) => backendService.delete(`product/${id}`).then(res => parseApiProduct(res.data)),
  setVisibility: (product: Product, visibility: boolean) => {
    const updatedProduct: UpdatedProduct = produce(product as UpdatedProduct,
      draft => {
        draft.visible = visibility;
        delete draft.image;
      });
    return backendService.put('/product', productToApiBody(updatedProduct)).then(res => parseApiProduct(res.data));
  },
};
